import { useState, useCallback } from "react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

const DEFAULT_PALETTE = [
  "#EF4444", "#F97316", "#EAB308", "#22C55E", "#3B82F6",
  "#6366F1", "#A855F7", "#EC4899", "#6B7280", "#FFFFFF", "#000000",
]

export function ColorPickerRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()
  const [selected, setSelected] = useState<string>("#3B82F6")

  const handleSelect = useCallback(
    (color: string) => {
      setSelected(color)
      dispatchEvent(element.id, "change", { value: color })
    },
    [element.id, dispatchEvent],
  )

  return (
    <div
      className={cn("flex flex-col gap-3", element.className)}
      data-testid={`color-picker-${element.id}`}
    >
      <div
        className="w-12 h-12 rounded-lg border border-border shadow-sm"
        style={{ backgroundColor: selected }}
        aria-label={`Selected color: ${selected}`}
      />
      <div className="flex flex-row flex-wrap gap-1.5">
        {DEFAULT_PALETTE.map((color) => (
          <button
            key={color}
            type="button"
            className={cn(
              "w-8 h-8 rounded-md border cursor-pointer transition-transform hover:scale-110",
              selected === color ? "border-primary border-2" : "border-border",
            )}
            style={{ backgroundColor: color }}
            onClick={() => handleSelect(color)}
            aria-label={`Select color ${color}`}
          >
            {selected === color && (
              <svg
                className="w-4 h-4 mx-auto"
                viewBox="0 0 24 24"
                fill="none"
                stroke={
                  ["#FFFFFF", "#EAB308", "#F97316"].includes(color)
                    ? "black"
                    : "white"
                }
                strokeWidth="3"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  )
}
